import { slicedToArray as _slicedToArray, asyncToGenerator as _asyncToGenerator, regeneratorRuntime as _regeneratorRuntime } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import { PurcsPreview } from '../CustomerWorkPreview.js';
import { Box, List, FlexBox, Typography, Icon, SquareImageContainer, FluidImage } from '@vp/swan';
import { useSearchContext } from '../../../searchContext/SearchContextProvider.js';
import localize from '../../../util/localize.js';
import FlyoutResult from './FlyoutResult.js';
import ResultText from './ResultText.js';

var HighlightQueryFromResultText = function HighlightQueryFromResultText(resultText) {
  var _useSearchContext = useSearchContext(),
    query = _useSearchContext.query;
  var startOfMatch = resultText.toLowerCase().indexOf(query);
  var queryLength = query.length;
  return startOfMatch === -1 ? resultText : resultText.slice(0, startOfMatch) + '<em>' + resultText.slice(startOfMatch, startOfMatch + queryLength) + '</em>' + resultText.slice(startOfMatch + queryLength);
};
var CustomerResult = function CustomerResult(_ref) {
  var _result$workEntity$pr, _result$design, _result$workEntity$re, _result$workEntity$pr2;
  var result = _ref.result,
    tenant = _ref.tenant;
  var _useSearchContext2 = useSearchContext(),
    locale = _useSearchContext2.locale;
  var purcsTenant = "".concat(tenant, "-prod");
  var ariaTitle = "".concat(result.name);
  var resultText = HighlightQueryFromResultText(result.name);
  var callToActionText = /*#__PURE__*/React__default.createElement(FlexBox, {
    alignItems: "flex-start"
  }, /*#__PURE__*/React__default.createElement(Typography, {
    fontWeight: "bold"
  }, result.resultType == 'order_history' ? localize('reorder', locale) : localize('finishEditing', locale)), /*#__PURE__*/React__default.createElement(Icon, {
    iconType: "arrowRight",
    size: "24p",
    pl: 1
  }));
  return /*#__PURE__*/React__default.createElement(FlyoutResult, {
    resultId: result.id,
    result: result,
    landingUrl: result.landingUrl,
    isCustomerResult: true
  }, result.workEntity ? /*#__PURE__*/React__default.createElement(Box, {
    className: "search-flyout-item-image-container",
    display: "flex"
  }, /*#__PURE__*/React__default.createElement(PurcsPreview, {
    locale: locale,
    width: 60,
    tenantId: purcsTenant,
    coreProductId: ((_result$workEntity$pr = result.workEntity.product) === null || _result$workEntity$pr === void 0 ? void 0 : _result$workEntity$pr.key) || ((_result$design = result.design) === null || _result$design === void 0 || (_result$design = _result$design.metadata) === null || _result$design === void 0 ? void 0 : _result$design.productKey) || ((_result$workEntity$re = result.workEntity.resources) === null || _result$workEntity$re === void 0 ? void 0 : _result$workEntity$re.productKey),
    coreProductVersion: (_result$workEntity$pr2 = result.workEntity.product) === null || _result$workEntity$pr2 === void 0 ? void 0 : _result$workEntity$pr2.version,
    renderingUrl: result.workEntity.design.displayUrl,
    optionSelections: result.workEntity.merchandising.merchandisingSelections
  })) : /*#__PURE__*/React__default.createElement(SquareImageContainer, {
    style: {
      width: '60px',
      flexShrink: 0
    }
  }, /*#__PURE__*/React__default.createElement(FluidImage, {
    src: result.livePreviewUrl,
    alt: "",
    margin: "auto"
  })), /*#__PURE__*/React__default.createElement(Box, {
    className: "customer-work-text-container",
    textAlign: "center"
  }, /*#__PURE__*/React__default.createElement(Box, {
    className: "search-flyout-item-name",
    textAlign: "left",
    pl: 3,
    pr: 2,
    pt: 1,
    ml: 3,
    style: {
      fontSize: '16px'
    }
  }, /*#__PURE__*/React__default.createElement("span", {
    "aria-hidden": "true"
  }, /*#__PURE__*/React__default.createElement(ResultText, {
    resultText: resultText
  }), /*#__PURE__*/React__default.createElement("span", {
    className: "swan-visually-hidden"
  }, ariaTitle))), /*#__PURE__*/React__default.createElement(Box, {
    className: "customer-work-cta",
    textAlign: "left",
    pl: 2,
    pr: 3,
    ml: 4
  }, callToActionText)));
};
var LocalizedCustomerWorkSection = function LocalizedCustomerWorkSection(Result) {
  return function (taxonomyHeadingLocalizer) {
    return function (_ref2) {
      var results = _ref2.results,
        maxResults = _ref2.maxResults,
        taxonomyConfiguration = _ref2.taxonomyConfiguration,
        headerId = _ref2.headerId;
      var _useSearchContext3 = useSearchContext(),
        locale = _useSearchContext3.locale;
      var resultsToRender = [];
      if (taxonomyConfiguration) {
        Object.keys(taxonomyConfiguration).forEach(function (resultType) {
          var limit = taxonomyConfiguration[resultType];
          var count = 0;
          results.forEach(function (result) {
            if (result.resultType === resultType && count < limit && resultsToRender.length < (maxResults || Infinity)) {
              resultsToRender.push(result);
              count++;
            }
          });
        });
      } else {
        resultsToRender = results.slice(0, maxResults || results.length);
      }
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Box, {
        as: "span",
        id: headerId
      }, taxonomyHeadingLocalizer(locale)), /*#__PURE__*/React__default.createElement(List, {
        skin: "minimal"
      }, resultsToRender.map(function (result) {
        return /*#__PURE__*/React__default.createElement(Result, {
          result: result,
          key: result.id
        });
      })), /*#__PURE__*/React__default.createElement(SeeAllSection, {
        results: results,
        locale: locale,
        configuration: taxonomyConfiguration
      }));
    };
  };
};
var GetUrlFromService = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(locale, urlId) {
    var url;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          url = encodeURI("https://url.prod.merch.vpsvc.com/v3/url/vistaprint/".concat(locale, "/").concat(urlId, "?requestor=omnisearch"));
          return _context.abrupt("return", fetch(url).then(function (res) {
            return res.json();
          }).then(function (data) {
            return data.url;
          }));
        case 2:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function GetUrlFromService(_x, _x2) {
    return _ref3.apply(this, arguments);
  };
}();
var SeeAllSection = function SeeAllSection(_ref4) {
  var results = _ref4.results,
    locale = _ref4.locale,
    configuration = _ref4.configuration;
  if (!configuration) {
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, null);
  }
  var _React$useState = React__default.useState(''),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    projectsLink = _React$useState2[0],
    setProjectsLink = _React$useState2[1];
  var _React$useState3 = React__default.useState(''),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    orderHistory = _React$useState4[0],
    setOrderHistoryLink = _React$useState4[1];
  React__default.useEffect(function () {
    var isCurrent = true;
    var setLinks = /*#__PURE__*/function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var projectsUrl, ordersUrl;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return GetUrlFromService(locale, 'ma:myProjects');
            case 2:
              projectsUrl = _context2.sent;
              _context2.next = 5;
              return GetUrlFromService(locale, 'ma:orderHistory');
            case 5:
              ordersUrl = _context2.sent;
              if (isCurrent) {
                setProjectsLink(projectsUrl);
                setOrderHistoryLink(ordersUrl);
              }
            case 7:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return function setLinks() {
        return _ref5.apply(this, arguments);
      };
    }();
    setLinks();
    return function () {
      isCurrent = false;
    };
  }, [locale]);

  // Calculate total results by result type to compare against configuration
  var resultCounts = results.reduce(function (total, result) {
    if (total[result.resultType]) {
      total[result.resultType]++;
    } else {
      total[result.resultType] = 1;
    }
    return total;
  }, {});

  // Which result types need a see all link
  var typesToSeeAll = Object.keys(resultCounts).reduce(function (total, resultType) {
    if (resultCounts[resultType] > configuration[resultType]) {
      total[resultType] = true;
    } else {
      total[resultType] = false;
    }
    return total;
  }, {});

  // If there's nothing to show just return an empty element
  if (!Object.values(typesToSeeAll).some(function (value) {
    return value;
  })) {
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, null);
  }

  //when we move from major version v2 to v3, we should update this function to use the js token package for consistency's sake.
  var seeAllLinks = Object.keys(typesToSeeAll).map(function (resultType) {
    if (typesToSeeAll[resultType] && resultType === 'order_history') {
      var ordersAndCount = localize('orders', locale).replace('{{{ numResults }}}', resultCounts[resultType]);
      return /*#__PURE__*/React__default.createElement(FlyoutResult, {
        landingUrl: orderHistory,
        resultId: 'seeAllOrders',
        key: 'seeAllOrders',
        result: {
          landingUrl: orderHistory
        },
        a11yLabel: "".concat(localize('seeAll', locale), " ").concat(ordersAndCount),
        display: 'inline-block',
        isCustomerWork: true,
        isCustomerResult: true,
        p: 0
      }, ordersAndCount);
    } else if (typesToSeeAll[resultType] && resultType === 'work_entity_service') {
      var projectsAndCount = localize('projects', locale).replace('{{{ numResults }}}', resultCounts[resultType]);
      return /*#__PURE__*/React__default.createElement(FlyoutResult, {
        landingUrl: projectsLink,
        resultId: 'seeAllProjects',
        key: 'seeAllProjects',
        result: {
          landingUrl: projectsLink
        },
        a11yLabel: "".concat(localize('seeAll', locale), " ").concat(projectsAndCount),
        display: 'inline-block',
        isCustomerWork: true,
        isCustomerResult: true
      }, projectsAndCount);
    }
  }).filter(function (e) {
    return !!e;
  });

  // Inject a pipe seperator between all see all section links
  if (seeAllLinks.length > 1) {
    for (var i = 1; i < seeAllLinks.length; i += 2) {
      seeAllLinks.splice(i, 0, /*#__PURE__*/React__default.createElement(Box, {
        as: "span",
        display: "inline-block",
        key: "separator-".concat(i)
      }, ' | '));
    }
  }
  return /*#__PURE__*/React__default.createElement(List, {
    skin: "minimal",
    className: "customer-work-see-all-links",
    pt: 5,
    pl: 2,
    display: "block",
    style: {
      fontSize: '12px'
    }
  }, localize('seeAll', locale), " ", seeAllLinks);
};
var CustomerWorkFlyoutTaxonomyRenderer = LocalizedCustomerWorkSection(CustomerResult);

export { CustomerWorkFlyoutTaxonomyRenderer as default };
//# sourceMappingURL=CustomerWorkRenderer.js.map
